// Services Map · tab Lịch dài hạn (Mint-ServicesMap `parseC`, `ltsRows`, `ltsKpis`): lưới Service × tuần tại cảng VN.
import type { ServiceRow } from './svcmap';

/** Tuần của lịch dài hạn: [mã tuần, ngày đầu tuần]. W43 là tuần này. */
export const LTS_WEEKS: readonly (readonly [string, string])[] = [['W43', '19/Oct'], ['W44', '26/Oct'], ['W45', '02/Nov'], ['W46', '09/Nov'], ['W47', '16/Nov'], ['W48', '23/Nov'], ['W49', '30/Nov'], ['W50', '07/Dec'], ['W51', '14/Dec']];

export type LtsKind = 'ok' | 'blank' | 'end' | 'nodata';
export interface LtsCell {
  kind: LtsKind;
  ves: string;
  etd: string;
  /** cờ: `dN` = đổi lịch N lần · `c` = đổi closing · `+tàu ETD` = thêm chuyến trong tuần */
  flag: string;
  now: boolean;
}

/** Ô lịch dài hạn dạng chuỗi `tàu chuyến|ETD|cờ` ('' = blank · '-' = chưa có dữ liệu · '>' = hết lịch đã nhập). */
export function parseCell(x: string, i: number): LtsCell {
  const [ves = '', etd = '', flag = ''] = x.split('|');
  const kind: LtsKind = x === '' ? 'blank' : x === '-' ? 'nodata' : x === '>' ? 'end' : 'ok';
  return { kind, ves, etd, flag, now: i === 0 };
}

export const delayCount = (c: LtsCell): number => Number(/^d(\d+)/.exec(c.flag)?.[1] ?? 0);

/** Tên tàu bỏ số chuyến cuối (nhãn ô). */
export const vesselName = (ves: string): string => ves.replace(/\s\S+$/, '');

/** Ô hiện trên lưới: số ngày ETD (+1 khi có thêm chuyến), cờ cảnh báo, nhãn và dòng phụ. */
export interface LtsCellView {
  kind: LtsKind;
  n: string;
  flag: boolean;
  label: string;
  sub: string;
  al: string;
}

export function cellView(code: string, raw: string, i: number): LtsCellView {
  const c = parseCell(raw, i);
  const wk = (LTS_WEEKS[i] ?? LTS_WEEKS[1]!)[0];
  if (c.kind === 'blank') return { kind: 'blank', n: '', flag: false, label: 'Blank sailing', sub: 'không có chuyến', al: `${code} ${wk} blank sailing` };
  if (c.kind === 'end') return { kind: 'end', n: '', flag: false, label: 'Hết lịch', sub: 'cần nhập', al: `${code} ${wk} hết lịch đã nhập` };
  if (c.kind === 'nodata') return { kind: 'nodata', n: '—', flag: false, label: '—', sub: 'chưa có dữ liệu', al: `${code} ${wk} chưa có dữ liệu` };
  const dl = delayCount(c);
  const extra = c.flag.startsWith('+');
  const sub = c.now
    ? dl ? `đã chạy ${c.etd} · đổi lịch ${dl} lần` : c.flag === 'c' ? `${c.etd} · đổi closing` : `đã chạy ${c.etd}`
    : c.etd + (extra ? ' · +1 chuyến' : '');
  return {
    kind: 'ok',
    n: (c.etd.split(' ')[0] ?? '') + (extra ? ' +1' : ''),
    flag: dl > 0 || c.flag === 'c',
    label: vesselName(c.ves),
    sub,
    al: `${code} ${wk} · ${c.ves} · ETD ${c.etd}${dl ? ` · đổi lịch ${dl} lần` : ''}${c.flag === 'c' ? ' · đổi closing' : ''}${extra ? ' · +1 chuyến' : ''}`,
  };
}

/** Service có thay đổi: có blank / hết lịch, hoặc tuần này bị đổi lịch / closing. */
export const hasChange = (s: ServiceRow, cells: readonly string[]): boolean => s.blank > 0 || s.ends > 0 || /\|[dc]/.test(cells[0] ?? '');

export const nowDelays = (rows: readonly { cells: readonly string[] }[]): number => rows.filter((r) => /\|d/.test(r.cells[0] ?? '')).length;
